import React from "react";
import HomeNewContainer from "../../components/user/homeNew";
import Layout from "../../components/layouts/verticalLayout";

const HomeNewPage = () => {
  return <Layout body={<HomeNewContainer />} />;
};

export default HomeNewPage;
